import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-33-martina-wettin-guest.webp";
import ThumbImg from "../../assets/images/conversations/033.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: gh-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .gh-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .gh-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .gh-hero { padding-top: 60px; padding-bottom: 60px; }
  .gh-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .gh-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .gh-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .gh-hero__title.gh-visible { opacity: 1; transform: translateY(0); }
  .gh-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .gh-hero__spotify.gh-visible { opacity: 1; transform: translateY(0); }
  .gh-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .gh-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .gh-hero__right.gh-visible { opacity: 1; transform: translateY(0); }

  .gh-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .gh-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .gh-yt-thumb:hover img { opacity: 0.85; }
  .gh-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .gh-yt-thumb__play img { width: 40px; height: 44px; }
  .gh-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .gh-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .gh-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .gh-body.gh-visible { opacity: 1; transform: translateY(0); }
  .gh-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .gh-body__para:last-child { margin-bottom: 0; }

  .gh-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .gh-guest.gh-visible { opacity: 1; transform: translateY(0); }
  .gh-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .gh-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .gh-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .gh-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .gh-inner { padding-left: 32px; padding-right: 32px; }
    .gh-hero { padding-top: 32px; padding-bottom: 48px; }
    .gh-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .gh-hero__title { font-size: 24px; }
    .gh-hero__left { gap: 16px; }
    .gh-guest__title { font-size: 24px; margin-bottom: 24px; }
    .gh-guest__photo-bg { width: 260px; height: 300px; }
    .gh-guest__name { font-size: 24px; margin-top: 18px; }
    .gh-body__para { font-size: 14px; margin-bottom: 12px; }
    .gh-body { padding-bottom: 48px; }
    .gh-guest { padding-bottom: 48px; }
    .gh-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .gh-inner { padding-left: 16px; padding-right: 16px; }
    .gh-hero { padding-top: 51px; padding-bottom: 30px; }
    .gh-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .gh-hero__left { gap: 30px; }
    .gh-hero__title { font-size: 30px; }
    .gh-body__para { font-size: 16px; margin-bottom: 10px; }
    .gh-guest__title { font-size: 30px; margin-bottom: 20px; }
    .gh-guest__photo-bg { width: 100%; height: 386px; }
    .gh-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .gh-body { padding-bottom: 30px; }
    .gh-guest { padding-bottom: 30px; }
    .gh-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("gh-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP33_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="gh-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 33 Green Hydrogen"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="gh-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 33 Green Hydrogen thumbnail" />
      <div className="gh-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="gh-hero">
      <div className="gh-inner">
        <div className="gh-hero__grid">
          <div className="gh-hero__left">
            <h1 ref={titleRef} className="gh-hero__title">
              EP | 33 Decarbonizing the Future: Exploring Small-Scale Off-Grid Generation of Green Hydrogen
            </h1>
            <div ref={spotifyRef} className="gh-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/5loWcD5BA05IinDaz4xlTZ?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 33 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="gh-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="gh-body">
      <div className="gh-inner">
        <p className="gh-body__para">
          In this episode, we are changing the pace and diving into the world of hydrogen. If you have been curious about the global hydrogen industry, how it works, and what it involves, this episode is especially for you. Today we go to Sweden to meet Nilsson Energy, a company that has developed a small-scale off-grid solution for generating hydrogen using solar or wind energy. This solution can help schools, communities, or even small towns to go off-grid and generate power 24/7 using 100% renewable energy using hydrogen electrolysers and fuel cells. Nilsson Energy's solution also generates hydrogen from the sun, which is used for clean mobility in cars and buses in the charming city of Mariestad in central Sweden. Today, we speak with the co-founder of Nilsson Energy, Martina Wettin, who is recognized as one of the global women leaders in hydrogen.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="gh-guest">
      <div className="gh-inner">
        <h2 className="gh-guest__title">Our Guest</h2>
        <div>
          <div className="gh-guest__photo-bg">
            <img src={GuestImg} alt="Martina Wettin" />
          </div>
          <p className="gh-guest__name">Martina Wettin</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep33GreenHydrogen() {
  return (
    <>
      <style>{CSS}</style>
      <div className="gh-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}